/*
 * Init date picker
 */
$(document).ready(function() {

  $("#datepicker").attr('placeholder', moment().format("dddd DD MMMM YYYY"));

  $("#reservation-button").on('click', function() {
    sendMail();
  } )
});

nextYear = parseInt(moment().format("YYYY") ) + 1;

var startDate,
  updateStartDate = function() {
      picker.setStartRange(startDate);
  },
  picker = new Pikaday({
      field: document.getElementById('datepicker'),
      format : "dddd DD MMMM YYYY",
      minDate: new Date(),
      maxDate: new Date(nextYear, 11, 31),
      disableDayFn: function(date){
        // Disable Monday
        return date.getDay() === 1;
      },
      onSelect: function() {
          startDate = this.getDate();
          updateStartDate();
      },
      firstDay: 1,
      onSelect: function() {
        // null
      },
      i18n: {
          previousMonth : 'Mese precedente',
          nextMonth     : 'Mese successivo',
          months        : ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
          weekdays      : ['Domenica','Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato'],
          weekdaysShort : ['Dom','Lun','Mar','Mer','Gio','Ven','Sab']
      },
  }),

  _startDate = picker.getDate();


/*
 * Send reserveation
 */
 $('#reservation-phone').keypress(function(e) {
   var a = [];
   var k = e.which;

   for (i = 48; i < 58; i++)
     a.push(i);

   if ( !(a.indexOf(k)>=0) ){
     e.preventDefault();
   }
 });

 $('#trattamento-dati').change(function() {
   if (!$(this).is(':checked')) {
     $('#reservation-button').attr('disabled', 'disabled');
   }else{
     $('#reservation-button').removeAttr('disabled');
   }
 });


 $("#reservation-number").keyup( function() {
   if( $(this).val().length > 2 ) {
     $(this).val( $(this).val().slice(0, 2) );
   }
 } );

 function validEmailAddress( email ) {
   var pattern = new RegExp( /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i );
   return pattern.test( email );
 }

 function keyupContent(attr){
   $(attr).bind("keyup change", function(e) {
     errorClass(this);
   });
 }

 function errorClass(err){
   if ( $(err).attr('id') == 'reservation-email' ){
     if ( !validEmailAddress( $(err).val() ) ){
       $(err).addClass('input-error');
       $(err).removeClass('input-correct');
     }else{
       $(err).removeClass('input-error');
       $(err).addClass('input-correct');
     }

   }else{
     if ( !$(err).val() ){
       $(err).addClass('input-error');
       $(err).removeClass('input-correct');
     }else{
       $(err).removeClass('input-error');
       $(err).addClass('input-correct');
     }
   }
 }

 function sendMail() {

   $('#reservation-form input, #reservation-form select').each(function () {
     keyupContent( $(this));
     errorClass(this);
   });

   var validation = true;
   $('#reservation-form input[type="text"], #reservation-form input[type="email"], #reservation-form select').each(function () {
     if( $(this).hasClass('input-error') ){
       validation = false;
     }
   });

   if( validation){

     sendReservation();

     $('.nome-prenotazione').html( $('#reservation-name').val() );
     $('.send-mail__success').delay( 1000 ).fadeIn().delay( 6000 ).fadeOut();

     setTimeout(function(){
       $('#reservation-form textarea, #reservation-form input, #reservation-form select').val( '' );
       $('.input-correct').removeClass('input-correct');
       $('#trattamento-dati').attr('checked', false);
       $('#reservation-button').attr('disabled', true );
     }, 1000);


   }else{
     $('.send-mail__success').fadeOut();
   }
 }




 // Send email
 function sendReservation() {

   var email_addr = $('input[type="email"]').val();

   $.post( "./api/newsletter-subscribe.php", { email:email_addr }, function( result ) {

   }, "json" );

   var html_message;

   html_message = "<p><strong>Messaggio da: </strong>" + $('#reservation-name').val() + "</p>";
   html_message += "<p><strong>Numero di telefono: </strong>" + $('#reservation-phone').val() + "</p>";
   html_message += "<p><strong>Email: </strong>" + $('#reservation-email').val() + "</p>";
   html_message += "<p><strong>Numero di persone: </strong>" + $('#reservation-number').val() + "</p>";
   html_message += "<p><strong>Orario della prenotazione: </strong>" + $('#reservation-hours').val() + "</p>";
   html_message += "<p><strong>Giorno della prenotazione: </strong>" + $('#datepicker').val() + "</p>";
   html_message += "<p><strong>Note sulla prenotazione: </strong>" + $('#reservation-note').val() + "</p>";

   $.post('https://mandrillapp.com/api/1.0/messages/send.json', {

     "key": "GDtUiH5JZKe63CoBiJRmDw",
     "message": {
       "html": html_message,
       "text": "Example text content",
       "subject": "Prenotazione tavolo da " + $('#reservation-name').val() + " per " + $('#datepicker').val() + " alle ore " + $('#reservation-hours').val(),
       "from_email": "info@osteriadelfilosso.it",
       "from_name": "Sito Osteria del Filosso",

       "to": [
         {
           "email": "info@osteriadelfilosso.it",
           "name": "Osteria Del Filosso",
           "type": "to"
         }
       ],

       "headers": {
         "Reply-To": $('#reservation-email').val(),
       },

       "important": false,
       "track_opens": null,
       "track_clicks": null,
       "auto_text": null,
       "auto_html": null,
       "inline_css": null,
       "url_strip_qs": null,
       "preserve_recipients": null,
       "view_content_link": null,
       //"bcc_address": "message.bcc_address@example.com",
       "tracking_domain": null,
       "signing_domain": null,
       "return_path_domain": null,
     },
   });
 }



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/reservations.js
 ** module id = 145
 ** module chunks = 0
 **/